export default "__VITE_ASSET__Dj6H07Dr__"